import { createGlobalStyle } from 'styled-components';
import { theme } from './theme';

export const GlobalStyles = createGlobalStyle<{ theme: typeof theme }>`
  html {
    background-color: ${({ theme }) => theme.palette.background.primary};
    font-size: ${({ theme }) => theme.rem}px;
  }
  body {
    margin: 0;
    font-family: ${({ theme }) => theme.typography.body.fontFamily};
    font-size: 1rem;
    overflow-x: hidden;
    color: ${({ theme }) => theme.palette.foreground.primary};
  }
`;
